import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNewPage, serverChanner, gmToolNewCom } from "@/mixins/index";
import { loginBeforeAnnounceUpdate, loginBeforeAnnounceAdd, gameByPkg } from "@/api/gmToolNew/gmToolNew";
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  mixins: [gmToolNewPage, serverChanner, gmToolNewCom],
  data: function data() {
    return {
      form: {
        language: "",
        content: "",
        date: [],
        id: "",
        channel: "",
        state: 1,
        pkgs: []
      },
      isserverChannel: true,
      formMark: {},
      dialogShow: false,
      pkgList: [],
      rules: {
        date: [{
          required: true,
          message: this.$t('pleaseSelectTime'),
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: this.$t('pleaseEnterContent'),
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: this.$t('pleaseSelectStatus'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.getPkgList();
    this.formMark = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  for (k in _this.formMark) {
                    _this.form[k] = data[k];
                  }

                  _this.form.date = [data.start_show_time, data.end_show_time];
                  _this.form.content = _this.$utils.textRepl(data.content);
                }

                _this.getannounceChannelData();

                _this.dialogShow = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getPkgList: function getPkgList() {
      var _this2 = this;

      gameByPkg({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.pkgList = res.data;
        }
      });
    },
    onEditorChange: function onEditorChange(e) {
      this.form.content = e;
    },
    clearData: function clearData(id) {
      this.form = _objectSpread({}, this.formMark);
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this3.form));
          data.start_show_time = data.date[0];
          data.end_show_time = data.date[1];
          delete data.date;
          data.content = data.content.replaceAll(_this3.$imgUrl, '');
          var reqFn = _this3.form.id ? loginBeforeAnnounceUpdate : loginBeforeAnnounceAdd;
          reqFn(_objectSpread(_objectSpread(_objectSpread({}, data), _this3.propsData), {}, {
            game_id: _this3.rawData.game_id
          })).then(function (res) {
            if (res.status == 200) {
              _this3.$message({
                message: _this3.$t('operationSuccess'),
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};